import { render, staticRenderFns } from "./PriceDataColumn.vue?vue&type=template&id=41e77e34&scoped=true"
import script from "./PriceDataColumn.vue?vue&type=script&lang=js"
export * from "./PriceDataColumn.vue?vue&type=script&lang=js"
import style0 from "./PriceDataColumn.vue?vue&type=style&index=0&id=41e77e34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e77e34",
  null
  
)

export default component.exports